import React, { useState, useRef, useEffect } from 'react';
import { Button } from '../ui/Button';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

/**
 * DownloadDropdown — single "Download ▾" button with CSV / PDF options.
 * Used on ReportDetail and ReportsPage (Overview). Extracted for reuse per RPT-1 wire.
 */
export default function DownloadDropdown({ hasData = true, onCSV, onPDF, disabled = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <Button
        variant="secondary"
        onClick={() => setOpen(!open)}
        disabled={disabled || !hasData}
      >
        Download
        <ChevronDownIcon className="h-4 w-4 ml-1" aria-hidden="true" />
      </Button>
      {open && (
        <div
          className="absolute right-0 mt-1 w-40 py-1 z-30"
          style={{
            backgroundColor: 'var(--color-surface)',
            border: '1px solid var(--color-border)',
            borderRadius: 'var(--radius-md)',
          }}
        >
          {onCSV && (
            <button
              type="button"
              onClick={() => { onCSV(); setOpen(false); }}
              className="block w-full text-left px-3 py-1.5 text-sm hover:bg-[color:var(--neutral-50)]"
              style={{ color: 'var(--color-text-default)' }}
            >
              Download CSV
            </button>
          )}
          {onPDF && (
            <button
              type="button"
              onClick={() => { onPDF(); setOpen(false); }}
              className="block w-full text-left px-3 py-1.5 text-sm hover:bg-[color:var(--neutral-50)]"
              style={{ color: 'var(--color-text-default)' }}
            >
              Download PDF
            </button>
          )}
        </div>
      )}
    </div>
  );
}
